.root {
  position: relative;
  display: block;
  overflow: hidden;
}

.image {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  max-width: none;
  transform-origin: 0 0;
  pointer-events: none;
  user-select: none;
}
